import { addColumnSetting } from "../../../services/columnSetting";

  export const addColumn = async ({  data}) =>{
    try {
      let response = await addColumnSetting({ data });
      if (response && response.data.success && response.data.data) {
        return response.data.data;
      } else {
        console.error("Invalid response structure:", response.data.data);
      }
    } catch (error) {
        // console.error('Failed category performance dashboard API calling :',error)
    }
  }